/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    GetAllGroups,
    GetVCCFactoriesByGroupID,
    GetFCCIQVsOQReport
};

async function GetAllGroups() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetVCCFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetVCCFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetFCCIQVsOQReport(model) {
    const response = await CommonPost('/api/FCCIQVsOQReport/GetFCCIQVsOQReport', null, model);
    return response.data;
}





